export default __webpack_public_path__ + "static/media/noexpl_09_EN.1edec17c.png";